import { render, staticRenderFns } from "./Structure_NoTabs.vue?vue&type=template&id=cd4b8e0c&"
import script from "./Structure_NoTabs.vue?vue&type=script&lang=js&"
export * from "./Structure_NoTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports